import classNames from "classnames";
import * as mask from "inputmask";
import _ from "lodash";
import pluralize from "pluralize";
import qs from "query-string";
import React from "react";
import { withRouter } from "react-router";
import {
  Button,
  Checkbox,
  Divider,
  Form,
  Input,
  InputGroup,
  Loader,
  Modal,
  Notification,
  Pagination,
  Panel,
  Table,
  Tooltip,
  Whisper,
  toaster,
} from "rsuite";
import { ParametersGlobals } from "../core/parametersGlobals/ParametersGlobals";
import { MethodsUtils } from "../core/utils/MethodsUtils";
import { CustomExtensions } from "../custom/CustomExtensions";
import axios from "../utilities/axios";
import { ColumnEditor } from "./ColumnEditor";
import { FilterableCell } from "./customTable/FilterableCell";
import { NecTable } from "./customTable/NecTable";
import { SchemaToParsedCell } from "./customTable/SchemaToParsedCell";
import { error } from "./errorList/main";
import { ErrorPopover } from "./errorPopover/main";
import { Permission } from "./Permission";
import iziToast from "izitoast";
import { RoleParticularitie } from "../core/interfaces/interfaces";
import { throws } from "assert";

const { Column, HeaderCell, Cell } = Table;

class Browserlize extends React.Component<any, {}> {

  public searchRef: any = null;
  public browserable: any = [];
  public state: any = {
    data: [],
    filters: [],
    selectedFilters: [],
    orders: [],
    checked: [],
    searchs: {},
    loading: false,
    operators: {},
    totalWidth: 0,
    loadingReportModal: false,
    isReportModalOpen: false,
    columnEditorOpen: false,
    genericSearchValue: "",
    sortColumn: null,
    sortType: null,
    isModalOpen: false,
    isExportModalOpen: false,
    importStep: 0,
    perPage: ParametersGlobals.perPage,
    totalPages: 4,
    totalItems: 0,
    page: 1,
    eventsClass: null,
    isImportModalOmie: false,
    isModalLabs: false,
    isModalLabsAdd: false,
    typeEquipment: [],
    typeEquipmentDisable: true,
    Retifier: null,
    typeRetifier: [],
    typeEquipmentSelect: [],
    retifierSelect: null,
    typeRetifierSelect: null,
    typeEquipmentAutomation: [],
    typeEquipmentAutomationSelect: [],
    typeTeste: [],
    idLabs: "",
    disableSelect: true,
    loadSelect: false,
    dataOmie: [],
    checkInactive: false,
    showConfirmDeleteChecklistModal: false,
    idToDeleteChecklist: 0,
    loadingConfirmInactiveModal: false,
    showConfirmActivateChecklistModal: false,
    idToReactivateChecklist: 0,
    loadingConfirmActivateModal: false,
    loadingReportChecklistButton: false,
    allCheckeds: false,
    selectDate: [] as [Date?, Date?],
    isSearchingData: false,
    roleParticularitie: [],
  };

  public elementRef: any = null;
  public eventsClass: any = null;

  updateEventsClass = () => {
    const $GLOBALS = this.props.form.$GLOBALS;
    if ($GLOBALS) {
      const eventName =
        _.upperFirst(pluralize.singular(_.camelCase($GLOBALS.table))) +
        "BrowseEvents";
      const eventHolder: any = CustomExtensions;
      if (eventHolder[eventName]) {
        this.eventsClass = new eventHolder[eventName]();
        this.setState({ eventsClass: this.eventsClass });
      }
    }
  };

  async componentDidMount() {
    const roleParticularitie: RoleParticularitie = await MethodsUtils.loadPermissionParticularitie(this.props.match.params.crud);

    if (roleParticularitie) {
      this.setState({ roleParticularitie: roleParticularitie }, () => {
        this.forceUpdate();
      });
    }

    const url = this.props.match.params.crud;
    this.elementRef = React.createRef();
    this.browserable = Object.values(this.props.form).filter((item: any) => {
      return item.canBrowse === true;
    });
    this.searchRef = React.createRef();
    this.updateEventsClass();

    var params = qs.parse(this.props.history.location.search);
    if (params) {
      var searchs: any = {};
      var operators: any = {};
      for (var i in params) {
        var param = params[i];
        if (i !== "page" && i !== "perPage" && i !== "sortType" && i !== "sortColumn" && i.substr(i.length - 3, i.length) !== "_op") {
          searchs[i] = param;
        }

        if (i.substr(i.length - 3, i.length) === "_op") {
          operators[i.replace("_op", "")] = param;
        }
        if (i === "sortType") {
          this.setState({ sortType: params[i] });
        }
        if (i === "sortColumn") {
          this.setState({ sortColumn: params[i] });
        }
      }

      this.setState({ searchs, operators }, () => {
        if (params && params.page && typeof params.page === "string") {
          if (params.perPage && typeof params.perPage === "string") {
            this.search(params.page, params.perPage);
          } else {
            this.search(params.page);
          }
        } else {
          this.search();
        }
      });
    }
  }

  componentDidUpdate(props: any, state: any) {
    if (this.props.location.search !== props.location.search) {
      var params = qs.parse(this.props.history.location.search);
      this.setState({ sortType: null, sortColumn: null });
      if (params) {
        var searchs: any = {};
        var operators: any = {};
        for (var i in params) {
          var param = params[i];
          if (
            i !== "page" &&
            i !== "perPage" &&
            i !== "sortType" &&
            i !== "sortColumn" &&
            i.substr(i.length - 3, i.length) !== "_op"
          ) {
            searchs[i] = param;
          }
          if (i.substr(i.length - 3, i.length) === "_op") {
            operators[i.replace("_op", "")] = param;
          }
          if (i === "sortType") {
            this.setState({ sortType: params[i] });
          }
          if (i === "sortColumn") {
            this.setState({ sortColumn: params[i] });
          }
        }
      }
    }
    if (
      this.state.totalWidth === 0 &&
      this.elementRef.current.clientWidth > 0
    ) {
      this.setState({ totalWidth: this.elementRef.current.clientWidth });
    }

    if (
      Object.keys(props.form).length > 0 &&
      this.state.filters.length <= 0 &&
      props.form?.$GLOBALS?.table &&
      this.props.form
    ) {
    }
  }

  onInactiveChecklist = async (id: number) => {
    this.setState({
      showConfirmDeleteChecklistModal: true,
      idToDeleteChecklist: id,
    });

    this.forceUpdate();
  };

  onActivateChecklist = async (id: number) => {
    this.setState({
      showConfirmActivateChecklistModal: true,
      idToReactivateChecklist: id,
    });

    this.forceUpdate();
  };

  onRead = (id: string) => {
    if (this.props.onRead) {
      this.props.onRead(id);
    }
  };

  onReadParticularitie = (id: string) => {
    if (this.props.onRead) {
      this.props.onRead(id + "?tab=particularities");
    }
  };

  onDelete = (id: string) => {
    if (this.props.onDelete) {
      this.props.onDelete(id, () => {
        this.search();
      });
    }
  };

  onEditLabs = (id: string) => {
    if (this.props.onEdit) {
    }
  };

  modalLabsEdit = async (id: string, idPsm: number) => {
    if (idPsm < 2) {
      iziToast.error({
        title: "Erro!",
        message: "A sua PSM não se encontra na situação correta para assumir",
        position: "topRight",
        close: true,
      });

      return;
    }
    localStorage.setItem("searchHistoric", this.props.location.search);
    axios.get("/api/v1/type_equipments/select").then((res) => {
      this.setState({
        typeEquipment: _.orderBy(res.data.items, ["value", "label"], ["asc"]),
        idLabs: id,
        typeEquipmentDisable: false,
      });
    });

    var templateLab: any = [];
    await axios.get("/api/v1/lab/check-template/" + id).then((res) => {
      templateLab = res.data.query;
    });
    if (templateLab.psm_template_type === null) {
      this.setState({ isModalLabs: true }, this.onSubmitSearch);
    } else {
      this.props.onEdit(id);
    }
  };

  onEdit = (id: string) => {
    if (this.props.onEdit) {
      this.props.onEdit(id);
    }
  };

  shouldComponentUpdate(nextProps: any, nextState: any) {
    if (this.props.form !== nextProps.form) {
      return true;
    }
    if (this.state.searchs !== nextState.searchs) {
      return true;
    }
    if (this.state.operators !== nextState.operators) {
      return true;
    }
    if (this.state.sortType !== nextState.sortType) {
      return true;
    }
    if (this.state.sortColumn !== nextState.sortColumn) {
      return true;
    }
    if (this.state.perPage !== nextState.perPage) {
      return true;
    }
    if (this.state.page !== nextState.page) {
      return true;
    }
    if (this.state.totalWidth !== nextState.totalWidth) {
      return true;
    }
    if (this.state.filters !== nextState.filters) {
      return true;
    }
    if (this.state.selectedFilters !== nextState.selectedFilters) {
      return true;
    }
    if (this.state.loading !== nextState.loading) {
      return true;
    }
    if (this.state.data !== nextState.data) {
      return true;
    }

    if (this.state.isReportModalOpen !== nextState.isReportModalOpen) {
      return true;
    }
    return false;
  }

  renderActions = (rowData: any) => {
    var idColumnName =
      this.props.form.$GLOBALS.prefix.toLocaleLowerCase() + "_id";

    const { edit: canEdit } = this.props.form.$GLOBALS;
    var { table: prefix } = this.props.form.$GLOBALS;
    if (this.props.overrideActions) {
      return this.props.overrideActions(rowData);
    }

    let updateStatusProject = (orientacao: any, id: any) => {
      const status: any = orientacao.orientacao;
      this.setState({ loading: true });

      if (status) {
        this.setState({ loading: true });

        const url = `/api/v1/projects/${status}/${id}`;

        axios
          .get(url)
          .then(async (res) => {
            if (res.status === 200) {
              this.setState({ loading: true });
              iziToast.success({
                title: "Sucesso!",
                message: `Situação alterada com sucesso para ${_.toUpper(status)}!`,
                position: "topRight",
                timeout: 3500,
                close: true,
              });

              setTimeout(() => {
                this.props.history.go(0);
              }, 2000);
            }
          })
          .catch((error) => {
            console.error("Error", error);
          });
      } else {
        console.error(
          "A propriedade 'orientacao' não está definida ou é vazia."
        );
      }
    };
    return (
      <>
        <div
          style={{ display: "flex", justifyContent: "flex-end", width: "100%", alignItems: "center" }}>
          <Permission name={prefix + "-read"}>
            <Whisper
              trigger="hover"
              delayClose={0}
              placement="top"
              speaker={<Tooltip>Visualizar</Tooltip>}>
              <i
                onClick={() => this.onRead(rowData[idColumnName])}
                className="fas text-primary fa-fw mr-2 clickable fa-eye"
              />
            </Whisper>
            {this.state.roleParticularitie.exceptionParticularitie && (
              <Whisper
                trigger="hover"
                delayClose={0}
                placement="top"
                speaker={<Tooltip>Particularidade</Tooltip>}>
                <Button
                  appearance="link">
                  <i
                    onClick={() => this.onReadParticularitie(rowData[idColumnName])}
                    className="text-primary fas fa-user-edit fa-fw mr-2" />
                </Button>
              </Whisper>
            )}
          </Permission>

          {canEdit !== false && this.props.name === "projects" && (
            <>
              {rowData?.["project_startedby_fk_user_id"] === null &&
                rowData?.["project_fk_situation_id"] === 1 && (
                  <Whisper
                    trigger="hover"
                    delayClose={0}
                    placement="top"
                    speaker={<Tooltip>Iniciar</Tooltip>}
                  >
                    <i
                      onClick={() =>
                        updateStatusProject(
                          { orientacao: "iniciado" },
                          rowData[idColumnName]
                        )
                      }
                      className="fas text-success fa-fw mr-2 clickable fas fa-play"
                    ></i>
                  </Whisper>
                )}

              {rowData?.["project_startedby_fk_user_id"] != null &&
                rowData["project_finishby_fk_user_id"] === null &&
                rowData?.["project_fk_project_sub_situation_id"] === 1 && (
                  <>
                    <Whisper
                      trigger="hover"
                      delayClose={0}
                      placement="top"
                      speaker={<Tooltip>Pausar</Tooltip>}
                    >
                      <i
                        onClick={() =>
                          updateStatusProject(
                            { orientacao: "pausado" },
                            rowData[idColumnName]
                          )
                        }
                        className="fas text-info fa-fw mr-2 clickable fas fa-pause"
                      ></i>
                      { }
                    </Whisper>
                    <Whisper
                      trigger="hover"
                      delayClose={0}
                      placement="top"
                      speaker={<Tooltip>Arquivar</Tooltip>}
                    >
                      <i
                        onClick={() =>
                          updateStatusProject(
                            { orientacao: "arquivado" },
                            rowData[idColumnName]
                          )
                        }
                        className="fas text-info fa-fw mr-2 clickable fas fa-archive"
                      ></i>
                      { }
                    </Whisper>
                  </>
                )}

              {rowData?.["project_startedby_fk_user_id"] != null &&
                rowData["project_finishby_fk_user_id"] === null &&
                rowData?.["project_fk_project_sub_situation_id"] === 2 && (
                  <>
                    <Whisper
                      trigger="hover"
                      delayClose={0}
                      placement="top"
                      speaker={<Tooltip>Reiniciar Projeto</Tooltip>}
                    >
                      <i
                        onClick={() =>
                          updateStatusProject(
                            { orientacao: "arquivado" },
                            rowData[idColumnName]
                          )
                        }
                        className="fas text-info fa-fw mr-2 clickable fas fa-archive"
                      ></i>
                      { }
                    </Whisper>
                  </>
                )}

              {rowData?.["project_startedby_fk_user_id"] != null &&
                rowData["project_finishby_fk_user_id"] === null &&
                rowData?.["project_fk_project_sub_situation_id"] === 3 && (
                  <>
                    <Whisper
                      trigger="hover"
                      delayClose={0}
                      placement="top"
                      speaker={<Tooltip>Reiniciar</Tooltip>}
                    >
                      <i
                        onClick={() =>
                          updateStatusProject(
                            { orientacao: "reiniciar" },
                            rowData[idColumnName]
                          )
                        }
                        className="fas text-success fa-fw mr-2 clickable fas fa-play"
                      ></i>
                    </Whisper>
                    <Whisper
                      trigger="hover"
                      delayClose={0}
                      placement="top"
                      speaker={<Tooltip>Arquivar</Tooltip>}
                    >
                      <i
                        onClick={() =>
                          updateStatusProject(
                            { orientacao: "arquivado" },
                            rowData[idColumnName]
                          )
                        }
                        className="fas text-info fa-fw mr-2 clickable fas fa-archive"
                      ></i>
                      { }
                    </Whisper>
                  </>
                )}
            </>
          )}

          {canEdit !== false && this.props.name !== "labs" && (
            <Permission name={prefix + "-edit"}>
              <Whisper
                trigger="hover"
                delayClose={0}
                placement="top"
                speaker={<Tooltip>Editar</Tooltip>}
              >
                <i
                  onClick={() => this.onEdit(rowData[idColumnName])}
                  className="fas text-warning fa-fw mr-2 clickable fa-pencil-alt"
                ></i>
              </Whisper>
              {this.props.actions
                ? this.props.actions(rowData[idColumnName], rowData)
                : null}
            </Permission>
          )}

          {canEdit !== false && this.props.name === "labs" && (
            <Permission name={prefix + "-edit"}>
              <Whisper
                trigger="hover"
                delayClose={0}
                placement="top"
                speaker={<Tooltip>Editar</Tooltip>}
              >
                <i
                  onClick={() =>
                    this.modalLabsEdit(
                      rowData[idColumnName],
                      rowData[`psm_status_fk_situation_id`]
                    )
                  }
                  className="fas text-warning fa-fw mr-2 clickable fa-pencil-alt"
                ></i>
              </Whisper>
              {this.props.actions
                ? this.props.actions(rowData[idColumnName], rowData)
                : null}
            </Permission>
          )}

          {this.props.form.$GLOBALS.delete !== false &&
            rowData.is_delete_safe !== true && (
              <Permission name={prefix + "-delete"}>
                <Whisper
                  trigger="hover"
                  delayClose={0}
                  placement="top"
                  speaker={<Tooltip>Excluir</Tooltip>}
                >
                  <i
                    onClick={() => this.onDelete(rowData[idColumnName])}
                    className="fas text-danger fa-fw mr-2 clickable fa-trash"
                  ></i>
                </Whisper>
              </Permission>
            )}
        </div>
      </>
    );
  };

  public lastData = {
    searchs: this.state.searchs,
    operators: this.state.operators,
  };

  onExitSearch = (key: string, value: string, operator: string) => {
    let { searchs, operators } = this.state;
    if (value === undefined) {
      delete searchs[key];
      if (operators[key]) {
        delete operators[key];
      }
    } else {
      searchs[key] = value;
      operators[key] = operator;
    }

    this.setState({ searchs, operators: operators }, () => {
      this.search();
    });
  };

  getVisibleHeadersWithOrder = (showHidden = true) => {
    if (this.state.filters && this.state.filters.length > 0) {
      return _.map(this.state.filters, (item) => {
        return this.props.form[item];
      });
    }

    return _.filter(
      _.orderBy(this.props.form, "browserOrder", "asc"),
      (item) => {
        return item.label?.length > 0;
      }
    );
  };

  onResize = (size: any, name: string) => {
    localStorage.setItem(
      this.props.form.$GLOBALS.prefix + "-size-" + name,
      size
    );
  };

  onCheckAll = () => {
    var checked = [];
    var value =
      this.state.checked.length === 0
        ? false
        : this.state.checked.length === this.state.data.length;
    if (value === false) {
      for (var i in this.state.data) {
        checked.push(
          this.state.data[i][
          this.props.form.$GLOBALS.prefix.toLocaleLowerCase() + "_id"
          ]
        );
      }
    }
    this.setState({ checked: checked });
  };

  onCheckAllPrint = () => {
    const isAllChecked = this.state.checked.length === this.state.data.length;
    let checked = [];

    if (!isAllChecked) {
      checked = this.state.data.map(
        (item: any) =>
          item[this.props.form.$GLOBALS.prefix.toLocaleLowerCase() + "_id"]
      );
    }

    this.setState(
      {
        checked,
        allCheckeds: !isAllChecked,
      },

      () => {
        this.forceUpdate();
      }
    );
  };

  onToggleCheck = (id: any) => {
    let { checked } = this.state;

    if (checked.includes(id)) {
      checked = checked.filter((item: any) => item !== id);
    } else {
      checked.push(id);
    }

    const isAllChecked = checked.length === this.state.data.length;

    this.setState(
      {
        checked,
        allCheckeds: isAllChecked,
      },
      () => {
        this.forceUpdate();
      }
    );
  };

  renderHeaders = () => {
    var output = [];
    if (this.props.modal !== true) {
      if (!this.state.checkInactive) {
        output.push(
          <Column key={"start"} align="left" width={40} fixed="left">
            {this.props.name === "filled_checklists" ? (
              <HeaderCell>
                {
                  <Checkbox
                    onChange={this.onCheckAllPrint}
                    checked={this.state.allCheckeds}
                  />
                }
              </HeaderCell>
            ) : (
              <HeaderCell>#{ }</HeaderCell>
            )}
            <Cell>
              {(rowData: any) => {
                var rowId =
                  rowData[
                  this.props.form.$GLOBALS.prefix.toLocaleLowerCase() + "_id"
                  ];
                return (
                  <div>
                    <Checkbox
                      onChange={() => this.onToggleCheck(rowId)}
                      checked={this.state.checked.includes(rowId)}
                    />
                  </div>
                );
              }}
            </Cell>
          </Column>
        );
      }
    }
    var filteredBrowserable = this.getVisibleHeadersWithOrder();

    var indexName = this.props.form.$GLOBALS.prefix + "_id";
    for (let i in filteredBrowserable) {
      let browse: any = filteredBrowserable[i];

      if (!browse) {
        continue;
      }
      if (!browse.canBrowse) {
        continue;
      }

      if (
        this.state.filters.includes(browse.name) ||
        this.state.filters.filter((item: any) => item != null).length <= 0
      ) {
        let width = browse.browserWidth
          ? browse.browserWidth * 100
          : _.clamp(
            (this.state.totalWidth - 130) / filteredBrowserable.length,
            browse.name.length * 9.4,
            this.state.totalWidth
          );
        if (
          localStorage.getItem(
            this.props.form.$GLOBALS.prefix + "-size-" + browse.name
          )
        ) {
          width = parseInt(
            localStorage.getItem(
              this.props.form.$GLOBALS.prefix + "-size-" + browse.name
            ) ?? "0"
          );
        }
        output.push(
          <Column
            key={i}
            align="left"
            resizable
            onResize={(size) => {
              this.onResize(size, browse.name);
            }}
            width={width}
          >
            <HeaderCell className="filterable">
              <FilterableCell
                field={browse}
                isIndex={browse.name === indexName}
                sortType={
                  this.state.sortType !== undefined &&
                    this.state.sortColumn === browse.name
                    ? this.state.sortType
                    : null
                }
                operator={
                  this.state.operators[browse.name] ??
                  (browse.type === "numeric" ? "eq" : "like")
                }
                onSortColumn={(value: string, operator: string = "like") =>
                  this.onSortColumn(browse.name, value, operator)
                }
                value={this.state.searchs[browse.name] ?? undefined}
                onExit={(value: string, operator: string) =>
                  this.onExitSearch(browse.name, value, operator)
                }
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: filteredBrowserable[i].label,
                  }}
                ></div>
              </FilterableCell>
            </HeaderCell>

            <Cell dataKey={browse.name.toLocaleLowerCase()}>
              {(rowData: any) => {
                return SchemaToParsedCell.parseFieldToValue(
                  browse,
                  rowData,
                  true
                );
              }}
            </Cell>
          </Column>
        );
      }
    }
    output.push(
      <Column key={"end"} align="right" width={100} fixed="right">
        <HeaderCell>Ações</HeaderCell>
        <Cell className="link-group">
          {(rowData: any) => {
            return this.renderActions(rowData);
          }}
        </Cell>
      </Column>
    );
    return output;
  };

  clearDate = () => {
    this.setState({ selectDate: [] as [Date?, Date?] }, () => {
      this.forceUpdate();
    });
    this.setState({ search: {} }, () => {
      window.location.search = "";
      this.forceUpdate();
      this.search();
    });
  };

  onSubmitSearch = () => {
    const ref: any = this.searchRef;
    var searchs: any = {};
    searchs["searchAll"] = ref?.current?.value;
    this.setState({ searchs }, () => {
      this.search();
    });
  };

  onSubmitFindDate = () => {
    this.setState({ loading: true });
    if (
      Array.isArray(this.state.selectDate) &&
      this.state.selectDate[0] &&
      this.state.selectDate[1]
    ) {
      var searchs: any = {
        dateStart: MethodsUtils.ConvertToDate(this.state.selectDate[0], false),
        dateFinish: MethodsUtils.ConvertToDate(this.state.selectDate[1], false),
      };

      this.setState({ searchs: searchs }, () => {
        this.forceUpdate();
        this.search();
      });
    } else {
      iziToast.warning({
        title: "Atenção!!!",
        message: "Nenhum intervalo de datas selecionado",
        position: "topRight",
        timeout: 3000,
        close: true,
      });

    }
  };

  search = (
    page: number | string = 1,
    perPage: string | number | null = null,
    apply: boolean = true
  ) => {
    perPage = ParametersGlobals.perPage;

    var operators: any = {};
    for (var i in this.state.operators) {
      operators[i + "_op"] = this.state.operators[i];
    }
    const uses = _.transform(
      this.props.uses ?? {},
      function (result: any, val: any, key: any) {
        result[key.toLowerCase()] = val;
      }
    );

    this.setState({ loading: true });
    var queryObj = {
      page,
      perPage,
      ...this.state.searchs,
      ...operators,
      sortType: this.state.sortType,
      sortColumn: this.state.sortColumn,
    };

    for (var queryIndex in queryObj) {
      if (queryObj[queryIndex] === null) {
        delete queryObj[queryIndex];
      }
    }
    localStorage.setItem(
      "perPage",
      typeof perPage === "number"
        ? ParametersGlobals.perPage.toString()
        : perPage
    );

    var urlQuery = qs.stringify(queryObj);

    if (apply) {
      if (this.props.modal !== true) {
        this.props.history.push(
          this.props.history.location.pathname + "?" + urlQuery
        );
      }
    }
    if (this.props.form.$GLOBALS && this.props.form.$GLOBALS.table) {
      axios
        .get("/api/v1/" + this.props.form.$GLOBALS.table + "/list/", {
          params: {
            ...this.props.uses,
            page,
            perPage,
            ...this.state.searchs,
            ...operators,
            sortType: this.state.sortType,
            sortBy: this.state.sortColumn,
            ...uses,
            searchValue: this.props.searchValue,
          },
        })
        .then((res) => {
          axios
            .get("/api/v1/me")
            .then((meResponse) => {
              const filterSetting = _.find(meResponse.data.user.user_settings, {
                user_setting_key: this.props.form.$GLOBALS.table + "-filters",
              });
              var filters: string[] = [];
              if (filterSetting && filterSetting.user_setting_value) {
                filters = JSON.parse(filterSetting.user_setting_value);
              }

              this.setState({
                loading: false,
                data: res.data.items,
                totalItems: res.data.pagination.total,
                perPage: res.data.pagination.perPage ?? perPage,
                page: res.data.pagination.page,
                filters,
              });
            })
            .catch((e) => {
              console.log("Erro Browserlize Search: ", e);
            });
        })
        .catch((e) => {
          console.error(e);
          error.add(e.message);

          if (e.response) {
            iziToast.error({
              title: "Erro!",
              message: e.response.data?.errors
                ? e.response.data.errors.join(", ")
                : e.message,
              position: "topRight",
              close: true,
            });

          }
          this.setState({ loading: false, data: [], perPage });
        })
        .finally(function () { });
    }
  };

  openReportModal = () => {
    this.setState(
      { loadingReportModal: true, isReportModalOpen: true },
      () => { }
    );
  };

  handleLoadingChecklistButtonOn() {
    this.setState(
      {
        loadingReportChecklistButton: true,
      },
      () => this.forceUpdate()
    );
  }

  handleLoadingChecklistButtonOff() {
    this.setState(
      {
        loadingReportChecklistButton: false,
      },
      () => this.forceUpdate()
    );
  }

  header = () => {
    let $GLOBALS = this.props.form.$GLOBALS;
    var { table: prefix } = this.props.form.$GLOBALS;
    const { add } = $GLOBALS;
    return (
      <>
        <div className="d-flex justify-contents-between align-items-center">
          <div></div>
          <div>
            <h5 className="d-flex align-items-center">
              {$GLOBALS.icon ? (
                <i
                  className={classNames(
                    "fas fa-fw mr-4",
                    "fa-" + $GLOBALS.icon
                  )}
                ></i>
              ) : (
                <ErrorPopover title="Missing icon">icon</ErrorPopover>
              )}
              Listagem de{" "}
              {$GLOBALS.plural_name ? (
                $GLOBALS.plural_name
              ) : (
                <ErrorPopover title="Missing singular/plural name">
                  {this.props.form.$GLOBALS.table}
                </ErrorPopover>
              )}
            </h5>
          </div>
          <div>
            <Whisper
              trigger="hover"
              placement="bottom"
              speaker={<Tooltip placement="bottom">Configurações</Tooltip>}
            >
              <Button
                color="blue"
                className="mr-2"
                onClick={() =>
                  this.setState({ columnEditorOpen: true }, this.onSubmitSearch)
                }
              >
                <i className="fas fa-fw fa-cogs"></i>
              </Button>
            </Whisper>
            {this.props.headers !== false &&
              add !== false &&
              this.props.name !== "checklist_parameters" &&
              this.props.name !== "filled_checklists" && (
                <Permission name={prefix + "-add"}>
                  <Whisper
                    trigger="hover"
                    placement="bottom"
                    speaker={<Tooltip placement="bottom">Adicionar</Tooltip>}
                  >
                    <Button
                      color="green"
                      onClick={() =>
                        this.props.history.push(
                          `/dashboard/${this.props.module}/${this.props.name}/add`
                        )
                      }
                    >
                      <i className="fas fa-fw fa-plus"></i>
                    </Button>
                  </Whisper>
                </Permission>
              )}
          </div>
        </div>
      </>
    );
  };

  filterData = () => {
    var mappedData = this.browserable.map((item: any) => {
      return {
        label: item.label
          ? item.label
            .replace(/<[^>]*>?/gm, "")
            .split("&nbsp;")
            .join("")
          : item.name,
        value: item.name,
      };
    });

    return mappedData;
  };

  onSortColumn = (
    sortColumn: string | null,
    sortType: string | null,
    operator: string = "like"
  ) => {
    if (sortType === null) {
      sortType = "asc";
    }
    if (
      this.state.sortType === "desc" &&
      sortType === "asc" &&
      sortColumn === this.state.sortColumn
    ) {
      sortType = null;
      sortColumn = null;
    }

    this.setState({ sortColumn, sortType }, () => {
      this.search();
    });
  };

  applyMask = () => {
    var rows = this.state.data;
    var data = this.filterData();
    for (var i in rows) {
      var row = rows[i];
      for (let name in row) {
        var isBrowsable =
          data.filter((item: any) => {
            return item.value === name;
          }).length > 0;

        if (isBrowsable) {
          var field = this.props.form[name];
          try {
            if (field.mask && field.mask.length > 0) {
              row[name] = mask.default.format(row[name], { mask: field.mask });
            }
          } catch (e) { }
        }
      }
    }
    return rows;
  };

  onRowDoubleClick = (row: any, index: any) => {
    if (this.props.onRowDoubleClick) {
      localStorage.setItem("searchHistoric", this.props.location.search);
      if (this.props.name === "labs" && row.psm_template_type === null) {
        iziToast.warning({
          title: "Aviso",
          message: "Favor clicar em editar para assumir a PSM!",
          position: "topRight",
          close: true,
        });

        return;
      }
      this.props.onRowDoubleClick(row, index);
    }
  };

  renderTable = () => {
    if (this.state.loading === true) {
      return (
        <div
          style={{
            height: 400,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Loader size={"lg"} />
        </div>
      );
    }
    var maskedData = this.applyMask();

    return (
      <div>
        <NecTable
          height={400 + 25 * (this.state.perPage - ParametersGlobals.perPage)}
          sortColumn={this.state.sortColumn}
          sortType={this.state.sortType}
          rowHeight={60}
          onRowDoubleClick={this.onRowDoubleClick}
          data={maskedData}
          renderEmpty={() => (
            <div className="rs-table-body-info o-2">
              Nenhum item encontrado.
            </div>
          )}
        >
          {this.renderHeaders()}
        </NecTable>
        {this.eventsClass && this.eventsClass["renderFooter"] && (
          <div className="table-bottom-items">
            {this.eventsClass["renderFooter"](this.props, this.state)}
          </div>
        )}
        <Divider />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <Pagination
              onChangeLimit={(limit: any) => this.search(1, limit)}
              limitOptions={[10, 15, 20, 40]}
              limit={this.state.perPage}
              total={this.state.totalItems}
              layout={["limit", "total"]}
            />
          </div>
          <div>
            <Pagination
              prev
              next
              first
              last
              onChangePage={(page: any) =>
                this.search(page, this.state.perPage)
              }
              activePage={Number(this.state.page)}
              total={this.state.totalItems}
              layout={["pager"]}
            />
          </div>
        </div>
      </div>
    );
  };

  closeAndSaveFilters = (filters: any) => {
    this.setState({ filters, columnEditorOpen: false });
  };

  closeAndDiscardFilters = () => {
    this.setState({ columnEditorOpen: false }, ()=> {this.forceUpdate()});
  }
  

  onSelectFilter = (value: any, nivel: any) => {
    if (value) {
      if (nivel === "nivel1") {
        this.setState({
          dataNivel2: { value: 0, label: "Nenhum" },
          dataNivel3: { value: 0, label: "Nenhum" },
        });
        this.setState({ dataNivel2: this.state.nivel2Filter[value] });
      }
      if (nivel === "nivel2") {
        this.setState({
          dataNivel3: { value: 0, label: "Nenhum" },
        });
        this.setState({ dataNivel3: this.state.nivel3Filter[value] });
      }
      this.search();
    }
  };

  handleDateChange = (value: [Date?, Date?]) => {
    this.setState({ selectDate: value }, () => {
      this.forceUpdate();
    });
  };

  render() {
    return (
      <>
        <Modal
          backdrop="static"
          open={this.state.showConfirmDeleteChecklistModal}
          onClose={() =>
            this.setState({ showConfirmDeleteChecklistModal: false })
          }
          size="xs"
        >
          <Modal.Body>
            <i
              className="fa fa-bell"
              style={{
                color: "#ffb300",
                fontSize: 24,
              }}
            />
            Tem a certeza de que deseja inativar este checklist?
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={async () => {
                this.setState({
                  loadingConfirmInactiveModal: true,
                });

                await axios.post("/api/v1/inactive-checklist", {
                  checklistId: this.state.idToDeleteChecklist,
                });

                this.setState({
                  showConfirmDeleteChecklistModal: false,
                  loadingConfirmInactiveModal: false,
                });

                window.location.reload();
              }}
              appearance="primary"
              loading={this.state.loadingConfirmInactiveModal}
            >
              Confirmar
            </Button>
            <Button
              onClick={() => {
                this.setState({ showConfirmDeleteChecklistModal: false });
                this.forceUpdate();
              }}
              appearance="subtle"
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        <div className="w-100" ref={this.elementRef}>
          <Panel bordered className="rs-no-body mb-4">
            {this.header()}
          </Panel>

          <Panel bordered className="rs-no-body mb-4">
            <Form onSubmit={this.onSubmitSearch}>
              <Form.Group>
                <InputGroup style={{ width: "100%" }}>
                  <Input
                    inputRef={this.searchRef}
                    placeholder={"Pesquisar por..."}
                    onPressEnter={this.onSubmitSearch}
                  />
                  <InputGroup.Button onClick={this.onSubmitSearch}>
                    <i className="fas fa-search fa-fw mr-2"></i>
                    Pesquisar
                  </InputGroup.Button>
                </InputGroup>
              </Form.Group>
            </Form>
          </Panel>

          {this.state.roleParticularitie.exceptionParticularitie && (
            <Panel bordered className="rs-no-body mb-4">
              <div style={{ display: "flex", justifyContent: "flex-end", flexDirection: "row" }}>
                <div>
                  <strong>Edição de Particularidade disponível</strong>
                </div>
                <div id="icon" style={{ marginLeft: "10px" }}>
                  <i className="text-primary fas fa-user-edit fa-fw mr-2"></i>
                </div>
              </div>
            </Panel>
          )}

          <Panel bordered bodyFill className="rs-no-body">
            {this.renderTable()}
          </Panel>

          <ColumnEditor
            onClose={this.closeAndDiscardFilters}
            onSave={this.closeAndSaveFilters}
            page={this.props.form.$GLOBALS.table}
            isOpen={this.state.columnEditorOpen}
          />
        </div>
      </>
    );
  }
}

export default withRouter(Browserlize);
